module.exports = __webpack_public_path__ + "img/seating-ex-titlebg.a9311bd0.jpeg";